import React from 'react';
import SpeedometerChart from './SpeedometerChart';
var Speedometer = function (_a) {
    var fields = _a.fields;
    if (!fields) {
        return null;
    }
    var chartValue = fields.chartValue, chartColor = fields.chartColor, graphicTitle = fields.graphicTitle, graphicBodyText = fields.graphicBodyText;
    return (React.createElement(SpeedometerChart, { chartValue: chartValue === null || chartValue === void 0 ? void 0 : chartValue.value, chartColor: chartColor === null || chartColor === void 0 ? void 0 : chartColor.value, title: graphicTitle === null || graphicTitle === void 0 ? void 0 : graphicTitle.value, bodyText: graphicBodyText === null || graphicBodyText === void 0 ? void 0 : graphicBodyText.value }));
};
export default Speedometer;
